import formatEnvironment from './formatEnv';

// Top-nav background color per environment (PD-3049), per the ticket's
// acceptance criteria. Environments not listed here (e.g. prod) keep the
// default bar.
const ENV_COLORS = {
  qa: '#584A00',
  staging: '#0A5889',
  'decisiv-paccar-escrow-20': '#0A5889', // staging-like escrow env
};

// The escrow alias should read as "Staging".
const normalizeEnv = (env) =>
  env === 'decisiv-paccar-escrow-20' ? 'staging' : env;

// Returns { color, label } for an environment that should highlight the top
// nav, or null when the default bar should be used (e.g. prod / unknown).
const resolveEnvTheme = (env) => {
  const color = ENV_COLORS[env];

  if (!color) return null;

  return { color, label: formatEnvironment(normalizeEnv(env)) };
};

export default resolveEnvTheme;
export { ENV_COLORS };
